import axios from "axios";
import { motion } from "framer-motion";
import React, { useContext, useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import VisibilitySensor from "react-visibility-sensor";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import Spacer from "../../components/Utils/Spacer";
import TitleHome from "../../components/Utils/TitleHome";
import { Context } from "../../context";
import classes from "./Demo.module.css";
import DemoCard from "./DemoCard";
const url = "https://demo-api.davidebalice.dev/api/demos?limit=6";

const Demo = () => {
  const [selectedCard, setSelectedCard] = useState(null);
  const [overlay, setOverlay] = useState(false);
  const [demoData, setDemoData] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const { debug, lang } = useContext(Context);

  const changeVisibility = (isVisibleSensor) => {
    if (isVisibleSensor && isVisible === false) {
      setIsVisible(true);
    }
  };

  const openPopupCard = (e, info, card) => {
    setSelectedCard(card);
    setOverlay(true);
  };

  const handleCloseCard = () => {
    setSelectedCard(null);
    setOverlay(false);
  };

  const getData = async () => {
    const response = await axios.get(url);
    console.log(response.data.demos);
    setDemoData(response.data.demos);
  };

  useEffect(() => {
    getData();
  }, []);

  let delay = 0;

  return (
    <>
      {overlay && <div className={classes.overlay}></div>}
      <section id="demoHome" className={`${classes.demoHome} section p_zero`}>
        <div className="py-5">
          <Container>
            <div className="mb-2">
              <div className="container">
                <TitleHome text="DemoAndCode = ({ demos })" color="black" />
              </div>
            </div>
          </Container>

          <Container>
            <div className="mb-2" style={{ marginLeft: "32px" }}>
              <VisibilitySensor
                onChange={changeVisibility}
                partialVisibility
                delayedCall
              >
                <motion.p
                  initial={{ opacity: 0, y: 12 }}
                  animate={{
                    opacity: isVisible ? 1 : 0,
                    y: isVisible ? 0 : 20,
                  }}
                  transition={{ duration: 0.4, delay: 0.2 }}
                  className="text-7 w-100 mb-1"
                >
                  {lang === "en" && <>Full systems demo, backend access</>}
                  {lang === "it" && <>Full systems demo, accesso al backend</>}
                </motion.p>
              </VisibilitySensor>

              <VisibilitySensor
                onChange={changeVisibility}
                partialVisibility
                delayedCall
              >
                <motion.p
                  initial={{ opacity: 0, y: 12 }}
                  animate={{
                    opacity: isVisible ? 1 : 0,
                    y: isVisible ? 0 : 20,
                  }}
                  transition={{ duration: 0.4, delay: 0.5 }}
                  className="text-6 w-100 align-self-center lh-base mb-4"
                >
                  {lang === "en" && <>Repository on GitHub</>}
                  {lang === "it" && <>Repository su GitHub</>}
                </motion.p>
              </VisibilitySensor>
            </div>
            <Container>
              <div className="mb-2">
                <div className="container">
                  <VisibilitySensor
                    onChange={changeVisibility}
                    partialVisibility
                    delayedCall
                  >
                    <motion.p
                      initial={{ opacity: 0, y: 12 }}
                      animate={{
                        opacity: isVisible ? 1 : 0,
                      }}
                      transition={{ duration: 0.4, delay: 0.8 }}
                      style={{ marginLeft: "8px" }}
                      className="text-4 text-left w-100 align-self-center lh-base mb-0"
                    >
                      {lang === "en" && (
                        <>
                          The{" "}
                          <strong className={classes.boldText}>demos</strong>{" "}
                          are built using modern technologies and serve as
                          examples of what can be achieved. They are intended
                          for{" "}
                          <strong className={classes.boldText}>
                            study purposes
                          </strong>
                          , some projects were initiated during{" "}
                          <strong className={classes.boldText}>
                            online courses
                          </strong>{" "}
                          and then continued and improved, while others were
                          developed{" "}
                          <strong className={classes.boldText}>
                            purely for fun
                          </strong>
                          . Backend access is limited, as a{" "}
                          <strong className={classes.boldText}>
                            DEMO MODE
                          </strong>{" "}
                          has been implemented via middleware to prevent CRUD
                          operations.
                          <br />
                          All source code is available on my{" "}
                          <strong>GitHub</strong>
                        </>
                      )}
                      {lang === "it" && (
                        <>
                          Le <strong className={classes.boldText}>demo</strong>{" "}
                          sono realizzate utilizzando tecnologie moderne e
                          rappresentano solo esempi delle possibilità di
                          sviluppo. Sono create{" "}
                          <strong className={classes.boldText}>
                            a scopo didattico
                          </strong>
                          : alcuni progetti sono stati avviati durante
                          <strong className={classes.boldText}>
                            {" "}
                            corsi online
                          </strong>{" "}
                          e successivamente proseguiti e migliorati, mentre
                          altre demo sono state sviluppate{" "}
                          <strong className={classes.boldText}>
                            per divertimento
                          </strong>
                          . L'accesso al backend è parziale, poiché è stata
                          attivata una{" "}
                          <strong className={classes.boldText}>
                            DEMO MODE{" "}
                          </strong>
                          tramite middleware che impedisce le operazioni CRUD.
                          <br />
                          Tutto il codice sorgente è disponibile sul mio{" "}
                          <strong> GitHub</strong>.
                        </>
                      )}
                    </motion.p>
                  </VisibilitySensor>
                </div>{" "}
              </div>
            </Container>
          </Container>
        </div>
        <Container
          fluid
          className={`${classes.demoCardContainer} text-center pb-5 pt-5`}
        >
          <div className="row gx-3 mx-lg-4 demo">
            {demoData
              .sort((a, b) => a.order - b.order)
              .slice(0, 6)
              .map((item) => {
                delay = delay + 0.1;
                return (
                  <DemoCard
                    key={"demoCardHome" + item._id}
                    {...item}
                    delay={delay}
                    card={item}
                    selectedCard={selectedCard}
                    openPopupCard={openPopupCard}
                    handleCloseCard={handleCloseCard}
                  />
                );
              })}
          </div>
        </Container>
        <VisibilitySensor
          onChange={changeVisibility}
          partialVisibility
          delayedCall
        >
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{
              opacity: isVisible ? 1 : 0,
              y: isVisible ? 0 : 20,
            }}
            transition={{ duration: 0.4, delay: delay }}
            className="text-center mb-5"
          >
            <a
              href="/demo"
              className="btn btn-outline-primary rounded-pill shadow-none smooth-scroll mt-2 mb-5"
            >
              Show all demos
            </a>
          </motion.div>
        </VisibilitySensor>
        <Container>
          <div className={classes.textCode1}>{`}`}</div>
          <Spacer height="50"></Spacer>
        </Container>
        <script src="vendor/jquery/jquery.min.js"></script>
        <script src="vendor/bootstrap/js/bootstrap.bundle.min.js"></script>
        <script src="js/theme.js"></script>
      </section>
    </>
  );
};

export default Demo;
